import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import config from '../config';
import axios from 'axios';

function EnrollmentContacts({ caseId, onError = () => {} }) {

    const currentUrl = `${config.API_URL}/EnrollmentAndEligibilityContacts/ByCaseId/${caseId}`;
    const originalUrl = `${config.API_URL}/EnrollmentAndEligibilityContacts/OriginalData/ByCaseId/${caseId}`;

    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchContacts();
    }, []);

    const fetchContacts = async () => {

        try {

            const [currentRes, originalRes] = await Promise.all([
                axios.get(currentUrl),
                axios.get(originalUrl)
            ]);

            const currentData = currentRes.data || [];
            const originalData = originalRes.data || [];

            const mergedData = currentData.map(current => {

                const original = originalData.find(
                    x => x.caseContactId === current.caseContactId
                );

                return {

                    ...current,

                    originalCarrier:
                        original?.carrierName || original?.carrierType || '',

                    originalBenefit:
                        original?.benefitName || original?.benefitType || '',

                    originalEmail:
                        original?.contactEmail || '',

                    originalStatus:
                        original?.contactStatus || ''

                };

            });

            setContacts(mergedData);

        } catch (error) {

            setError('Error fetching contacts.');
            onError(error);

        } finally {

            setLoading(false);

        }
    };

    if (loading) return <Skeleton count={10} />;
    if (error) return <div>{error}</div>;

    return (
        <Col lg={12} className="mb-3">

            <Card>

                <Card.Body>

                    <Row>

                        <Col lg={6}>
                            <Card.Title>
                                Enrollment and Eligibility Contacts
                            </Card.Title>
                        </Col>

                    </Row>

                    <div className="table-responsive">

                        {contacts.length ? (

                            <table className="table table-bordered">

                                <thead>
                                    <tr>
                                        <th>Description</th>

                                        <th>Original Email</th>
                                        <th>Changed Email</th>

                                        <th>Original Carrier</th>
                                        <th>Changed Carrier</th>

                                        <th>Original Benefit</th>
                                        <th>Changed Benefit</th>

                                        <th>Original Status</th>
                                        <th>Changed Status</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {contacts.map((contact, index) => {

                                        const currentCarrier =
                                            contact.carrierName || contact.carrierType || '';

                                        const currentBenefit =
                                            contact.benefitName || contact.benefitType || '';

                                        return (

                                            <tr key={index}>

                                                {/* Description */}
                                                <td>
                                                    {contact.contactDescription || '-'}
                                                </td>

                                                {/* Original Email */}
                                                <td>
                                                    {contact.originalEmail || '-'}
                                                </td>

                                                {/* Changed Email */}
                                                <td
                                                    style={{
                                                        backgroundColor:
                                                            contact.contactEmail !== contact.originalEmail
                                                                ? 'yellow'
                                                                : 'transparent'
                                                    }}
                                                >
                                                    {
                                                        contact.contactEmail !== contact.originalEmail
                                                            ? contact.contactEmail
                                                            : '-'
                                                    }
                                                </td>

                                                {/* Original Carrier */}
                                                <td>
                                                    {contact.originalCarrier || '-'}
                                                </td>

                                                {/* Changed Carrier */}
                                                <td
                                                    style={{
                                                        backgroundColor:
                                                            currentCarrier !== contact.originalCarrier
                                                                ? 'yellow'
                                                                : 'transparent'
                                                    }}
                                                >
                                                    {
                                                        currentCarrier !== contact.originalCarrier
                                                            ? currentCarrier
                                                            : '-'
                                                    }
                                                </td>

                                                {/* Original Benefit */}
                                                <td>
                                                    {contact.originalBenefit || '-'}
                                                </td>

                                                {/* Changed Benefit */}
                                                <td
                                                    style={{
                                                        backgroundColor:
                                                            currentBenefit !== contact.originalBenefit
                                                                ? 'yellow'
                                                                : 'transparent'
                                                    }}
                                                >
                                                    {
                                                        currentBenefit !== contact.originalBenefit
                                                            ? currentBenefit
                                                            : '-'
                                                    }
                                                </td>

                                                {/* Original Status */}
                                                <td>
                                                    {contact.originalStatus || '-'}
                                                </td>

                                                {/* Changed Status */}
                                                <td
                                                    style={{
                                                        backgroundColor:
                                                            contact.contactStatus !== contact.originalStatus
                                                                ? 'yellow'
                                                                : 'transparent'
                                                    }}
                                                >
                                                    {
                                                        contact.contactStatus !== contact.originalStatus
                                                            ? contact.contactStatus
                                                            : '-'
                                                    }
                                                </td>

                                            </tr>

                                        );

                                    })}

                                </tbody>

                            </table>

                        ) : (

                            <h3>No Contacts</h3>

                        )}

                    </div>

                </Card.Body>

            </Card>

        </Col>
    );
}

export default EnrollmentContacts;